var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"iframe",attrs:{"src":_vm.dashboard.url,"id":"iframe","allowtransparency":"","frameborder":"0"},on:{"load":_vm.frameLoaded}})}
var staticRenderFns = []

export { render, staticRenderFns }